module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_1000000-bd4aa92545f8f296d694ef5d593b3d9d.png";